import React, { FC, memo } from 'react';
import styled from 'styled-components';
import {
  IImageInfoType,
  IProjectImageInfoType
} from '../../../types/record/image-info';

const Root = styled.div`
  border: solid 2px black;
  width: 100%;
  height: 100%;
  /* background-color: #cdcdcd; */
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

interface Props {
  image: IImageInfoType | IProjectImageInfoType;
}

export const ImageThumbnail: FC<Props> = memo(({ image }: Readonly<Props>) => (
  <Root>
    <Img src={image.fileUri} alt={image.id.toString()} />
  </Root>
));

ImageThumbnail.displayName = 'ImageThumbnail';
